import { GridCell } from '@progress/kendo-react-grid'
import React from 'react'
import '../styles.css'

export class StatusCell extends GridCell {
  public render() {
    const status = this.props.dataItem[this.props.field]
    if (status === false) {
      return  <td>
                <span className="failed">
                  <i className="fas fa-times-circle"></i>
                </span>
              </td>
    } else if (status === true) {
        return  <td>
                  <span className="verified">
                    <i className="fas fa-check-circle"></i>
                  </span>
                </td>
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/integration-mappings/render/status_cell.tsx